const appConfig = {
  "name": "leave-supervisor-v2-main",
  "version": "0.1.0",
  "stage": "dev",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shg1319alZcDf697",
    "clientId": "32k81b4vcd5i1pm2l2a16jv83n",
    "redirectUris": [
      "https://leave-supervisor-v2.atlas-apps-dev.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://leave-supervisor-v2.atlas-apps-dev.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "feature/user",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "sap-proxy/execute-rfc",
      "sap-proxy/function",
      "sap-proxy/status",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_14cFcpuS8",
    "userPoolWebClientId": "32k81b4vcd5i1pm2l2a16jv83n",
    "oauth": {
      "domain": "atlas-auth-dev.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "feature/user",
        "openid",
        "profile",
        "sap-proxy/execute-rfc",
        "sap-proxy/function",
        "sap-proxy/status",
        "user/all"
      ],
      "redirectUris": [
        "https://leave-supervisor-v2.atlas-apps-dev.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://leave-supervisor-v2.atlas-apps-dev.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;